import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { DetailInnerSection } from '@/components/ui/layouts/sections/DetailInnerSection';
import { useContext } from 'react';
import { Instances } from '../Instances';

export const LanguageCourseDetailSection = ({ data, sectionId }) => {
  const { st } = useContext(StaticTextContext);
  const isRelation = data._isRelationTitle ?? !!data?.meta?.has_relations;

  return (
    <DetailInnerSection
      anchor={{
        text: st('body.goto'),
        link: sectionId ? `#${sectionId}` : null,
      }}
      heading={{
        title: data?.fields?.title,
        description: data?.fields?.description,
      }}
      id={data?.fields?.id}
      isRelation={isRelation}
    >
      <Instances
        instances={data?.relations?.LanguageCourseDetailSectionBlocks}
        isRelation={isRelation}
      />
    </DetailInnerSection>
  );
};
